import { render } from "./DDatePicker.vue?vue&type=template&id=7a372980"
import script from "./DDatePicker.vue?vue&type=script&lang=ts"
export * from "./DDatePicker.vue?vue&type=script&lang=ts"
script.render = render

export default script